import React, { useEffect, useState } from 'react'
import Carousel from '../../../../../../Carousel'
// Icons
import { ReactComponent as Arrow } from './icons/arrow.svg'
import useDetectDevice from '../../../../../../../hooks/useDetectDevice'

function Slider({ items, hideSidePadding, onUpdate, shown }) {
  const [slider, setSlider] = useState()

  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  const [hasScroll, setHasScroll] = useState(undefined)

  useEffect(() => {
    if (!slider) return

    const handleSlideChange = () => {
      setIsBeginning(slider.isBeginning)
      setIsEnd(slider.isEnd)
    }

    slider.on('slideChange', handleSlideChange)

    // Initial check
    handleSlideChange()

    return () => {
      slider.off('slideChange', handleSlideChange)
    }
  }, [slider])

  const [update, setUpdate] = useState(false)

  useEffect(() => {
    onUpdate &&
      onUpdate({
        hasScroll,
      })
  }, [update, hasScroll])

  const [visible, setVisible] = useState(false)

  useEffect(()=>{
    if(hasScroll !== undefined) {
      setVisible(true)
    }
  }, [hasScroll])


  const { isMobile } = useDetectDevice()

  return (
    <div className={`flex items-center justify-center ${visible || isMobile ? 'opacity-100' : 'opacity-0'} transition-all`}>
      {!hideSidePadding && (
        <div className={`pr-[24px] flex-shrink-0 transition-all ${hasScroll ? 'opacity-100' : 'opacity-0'}`}>
          <button
            type="button"
            className={`${slider?.isBeginning ? 'opacity-30 pointer-events-none' : ''} rotate-180`}
            onClick={() => {
              slider.slidePrev()
              setTimeout(() => setUpdate((prev) => !prev), 100)
            }}
          >
            <Arrow />
          </button>
        </div>
      )}
      <Carousel
        className="w-full flex-1 hide-navigation"
        // spaceBetween={20}
        slidesPerView="auto"
        loop={false}
        centeredSlides={false}
        onSwiper={setSlider}
        onInit={(swiper) => shown && setHasScroll(!swiper.isLocked)}
        onResize={(swiper) => shown && setHasScroll(!swiper.isLocked)}
        // slidesOffsetAfter={20}
        // grabCursor={true}
        onReachEnd={() => {
          setTimeout(() => setUpdate((prev) => !prev), 100)
        }}
        onReachBeginning={() => {
          setTimeout(() => setUpdate((prev) => !prev), 100)
        }}
        navigation={true}
        pagination={{ clickable: true }}
        slides={items.map((c) => c.content)}
      />
      {!hideSidePadding && (
        <div className={` pl-[24px] flex-shrink-0 transition-all ${hasScroll ? 'opacity-100' : 'opacity-0'}`}>
          <button
            type="button"
            className={`${slider?.isEnd ? 'opacity-30 pointer-events-none' : ''}`}
            onClick={() => {
              slider.slideNext()
              setTimeout(() => setUpdate((prev) => !prev), 100)
            }}
          >
            <Arrow />
          </button>
        </div>
      )}
    </div>
  )
}

export default Slider
